import React, { useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
// import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';
import connectedGif from '../assets/images/connected.gif';
import connectedImg from '../assets/images/connectedImg.gif';
import DisconnectedImg from '../assets/images/DisconnectedImg.gif';
import Lottie from "lottie-react";
import creationModeAnimation from "../assets/images/Animation.json";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import {
    ChevronDown,
    ClipboardCopy,
    ThumbsUp,
    ThumbsDown,
    SendHorizontal,
    CircleCheck,
    Image,
    FileText,
    Mic,
    User,
    Menu,
    Clock, Star, Plus, ChevronLeft, ChevronRight, X
} from "lucide-react";
import configData from "../configData.json";
import AgentPoster from '../assets/images/AgentPoster.png';
import { animateScroll as scrollLibrary } from "react-scroll";

import autobahn from "autobahn";
import CryptoJS from 'crypto-js';

import NewHome from "./newHomeforDemo";

import OtpAuthModal from "./OtpAuthModal";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Agents from "../components/Agent/Agents";
import CreateAgentForm from "../pages/CreateAgentForm";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;






const TypeWriterForSubtitle = ({ text, duration, isIdle }) => {
    const [displayText, setDisplayText] = useState("");
    const charIndexRef = useRef(0);
    const intervalRef = useRef(null);
    const hasCompletedRef = useRef(false);

    useEffect(() => {
        // Reset when new text arrives
        if (text !== displayText) {
            charIndexRef.current = 0;
            hasCompletedRef.current = false;
            setDisplayText("");
            startAnimation();
        }

        return () => stopAnimation();
    }, [text, duration]);

    const startAnimation = () => {
        if (hasCompletedRef.current || !text || duration <= 0 || isIdle) {
            return;
        }

        stopAnimation();

        const charDelay = (duration * 1000) / text.length;
        let currentText = '';

        intervalRef.current = setInterval(() => {
            if (charIndexRef.current >= text.length) {
                stopAnimation();
                hasCompletedRef.current = true;
                return;
            }

            currentText += text[charIndexRef.current];
            setDisplayText(currentText);
            charIndexRef.current += 1;
        }, charDelay);
    };

    const stopAnimation = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    if (isIdle) {
        return text;
    }

    return <div>{displayText}</div>;
};

const ThinkingProcessContainer = ({ thinkingMessages, onToggleMain, onToggleIndividual, isMainExpanded }) => {
    const [displayedTexts, setDisplayedTexts] = useState({});

    useEffect(() => {
        // Initialize displayed texts for each thinking message
        const initialTexts = {};
        thinkingMessages.forEach(msg => {
            initialTexts[msg.id] = '';
        });
        setDisplayedTexts(initialTexts);
    }, [thinkingMessages]);

    useEffect(() => {
        // Animate text for expanded thinking messages
        thinkingMessages.forEach(message => {
            if (message.isExpanded && message.content) {
                let index = 0;
                const text = message.content;

                const timer = setInterval(() => {
                    if (index < text.length) {
                        setDisplayedTexts(prev => ({
                            ...prev,
                            [message.id]: text.slice(0, index + 1)
                        }));
                        index++;
                    } else {
                        clearInterval(timer);
                    }
                }, 20);

                return () => clearInterval(timer);
            }
        });
    }, [thinkingMessages.map(msg => `${msg.id}-${msg.isExpanded}`).join(',')]);

    const formatDuration = (durationInSeconds) => {
        if (!durationInSeconds) return '';
        if (durationInSeconds < 1) {
            return `${Math.round(durationInSeconds * 1000)}ms`;
        } else if (durationInSeconds < 60) {
            return `${durationInSeconds.toFixed(1)}s`;
        } else {
            const minutes = Math.floor(durationInSeconds / 60);
            const seconds = Math.round(durationInSeconds % 60);
            return `${minutes}m ${seconds}s`;
        }
    };

    const shouldAutoScroll = (content) => {
        if (!content) return false;
        const words = content.trim().split(/\s+/).length;
        const lines = content.split('\n').length;
        return words > 30 || lines > 2;
    };

    // Get the current/latest thinking step to show preview
    const getCurrentThinkingPreview = () => {
        if (!thinkingMessages || thinkingMessages.length === 0) return '';

        // Find the latest thinking step (last one in the array)
        const latestStep = thinkingMessages[thinkingMessages.length - 1];

        if (!latestStep || !latestStep.content) return '';

        // Get first 5-6 words as preview
        const words = latestStep.content.trim().split(/\s+/);
        const preview = words.slice(0, 6).join(' ');

        // Add ellipsis if there are more words
        return words.length > 6 ? `${preview}...` : preview;
    };

    const isAllCompleted = thinkingMessages.every(msg => msg.isCompleted);
    const totalDuration = thinkingMessages.reduce((sum, msg) => sum + (msg.duration || 0), 0);
    const currentPreview = getCurrentThinkingPreview();

    return (
        <div className="border border-gray-300 rounded-lg mb-4 overflow-hidden bg-gray-50">
            {/* Main thinking process header */}
            <button
                onClick={onToggleMain}
                className="w-full p-4 bg-gray-50 hover:bg-gray-100 text-left flex items-center justify-between transition-colors group"
            >
                <div className="flex items-center gap-3 flex-1 min-w-0">
                    <div className="flex gap-1 flex-shrink-0">
                        {isAllCompleted ? (
                            <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="text-white">
                                    <path d="M3 6L5 8L9 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        ) : (
                            <>
                                <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse delay-0"></div>
                                <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse delay-200"></div>
                                <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse delay-[400ms]"></div>
                            </>
                        )}
                    </div>

                    <div className="flex flex-col items-start min-w-0 flex-1">
                        <span className="text-gray-700 font-medium flex-shrink-0">
                            {isAllCompleted ? "Thought process (completed)" : "Thought process"}
                        </span>

                        {/* Show current thinking preview when not expanded and not completed */}
                        {!isMainExpanded && !isAllCompleted && currentPreview && (
                            <span className="text-xs text-gray-500 truncate max-w-full mt-1 font-mono">
                                {currentPreview}
                            </span>
                        )}

                        {/* Show duration when collapsed and completed */}
                        {!isMainExpanded && isAllCompleted && totalDuration > 0 && (
                            <span className="text-xs text-gray-500 mt-1">
                                {formatDuration(totalDuration)}
                            </span>
                        )}
                    </div>
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                    {!isMainExpanded && totalDuration > 0 && isAllCompleted && (
                        <span className="text-sm text-gray-500">{formatDuration(totalDuration)}</span>
                    )}
                    <div className={`transform transition-transform duration-200 ${isMainExpanded ? 'rotate-180' : ''}`}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-gray-500">
                            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            </button>

            {/* Individual thinking steps */}
            {isMainExpanded && (
                <div className="border-t border-gray-200 bg-white">
                    <div className="p-4 space-y-3">
                        {thinkingMessages.map((message, index) => (
                            <div key={message.id} className="border border-gray-200 rounded-md overflow-hidden">
                                {/* Individual thinking step header */}
                                <button
                                    onClick={() => onToggleIndividual(message.id)}
                                    className="w-full p-3 bg-gray-50 hover:bg-gray-100 text-left flex items-center justify-between transition-colors text-sm"
                                >
                                    <div className="flex items-center gap-2 min-w-0 flex-1">
                                        <div className="flex gap-1 flex-shrink-0">
                                            {message.isCompleted ? (
                                                <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center">
                                                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" className="text-white">
                                                        <path d="M2 4L3.5 5.5L6 2.5" stroke="white" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse delay-0"></div>
                                                    <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse delay-200"></div>
                                                    <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse delay-[400ms]"></div>
                                                </>
                                            )}
                                        </div>
                                        <span className="text-gray-600 font-medium flex-shrink-0">
                                            Step {index + 1}
                                        </span>
                                        {!message.isExpanded && message.content && (
                                            <span className="text-xs text-gray-500 truncate min-w-0 font-mono">
                                                {message.content.slice(0, 50)}{message.content.length > 50 ? '...' : ''}
                                            </span>
                                        )}
                                    </div>

                                    <div className={`transform transition-transform duration-200 flex-shrink-0 ${message.isExpanded ? 'rotate-180' : ''}`}>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="text-gray-400">
                                            <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </button>

                                {/* Individual thinking step content */}
                                {message.isExpanded && (
                                    <div className="border-t border-gray-200 bg-white">
                                        <div className={`p-3 ${shouldAutoScroll(message.content) ? 'max-h-40 overflow-y-auto' : ''}`}>
                                            <div className="text-gray-700 whitespace-pre-wrap font-mono text-xs leading-relaxed">
                                                {displayedTexts[message.id] || ''}
                                                {displayedTexts[message.id] && displayedTexts[message.id].length < (message.content?.length || 0) && !message.isCompleted && (
                                                    <span className="animate-pulse">|</span>
                                                )}
                                            </div>
                                            {message.duration && (
                                                <div className="mt-2 pt-2 border-t border-gray-200 text-xs text-gray-500">
                                                    Step duration: {formatDuration(message.duration)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}

                        {/* Total duration at the bottom */}
                        {totalDuration > 0 && (
                            <div className="mt-3 pt-3 border-t border-gray-200 text-xs text-gray-500 text-center">
                                Total thinking time: {formatDuration(totalDuration)}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};


const ChatInterface = ({ agentData }) => {
    const navigate = useNavigate();
    const { agentName } = useParams();

    const videoRef = useRef(null);
    const audioRef = useRef(null);
    const textareaRef = useRef(null);
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState("");
    const [pdffileUrl, setpdfFileUrl] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);
    const [videoUrl, setVideoUrl] = useState(
    );

    const [currentThinkingId, setCurrentThinkingId] = useState(null);
    const [thinkingStartTime, setThinkingStartTime] = useState(null);


    const [loading, setLoading] = useState(true);
    const [requestId, setRequestId] = useState(null)
    const [audioUrl, setAudioUrl] = useState(null);
    const messagesEndRef = useRef(null);
    const [userImage, setUserImage] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showAgentsOverlay, setShowAgentsOverlay] = useState(false);
    const [fileUrl, setFileUrl] = useState(null);
    const connectionRef = useRef(null);
    const [displayedText, setDisplayedText] = useState('');
    const [showContent, setShowContent] = useState(false);
    const [connectionStatus, setConnectionStatus] = useState("Disconnected");
    const [messagesauto, setMessagesauto] = useState([]);
    const [codeContent, setCodeContent] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [error, setError] = useState(null);
    const [allAgents, setAllAgents] = useState([])
    const [currentAgent, setCurrentAgent] = useState()
    const [duration, setDuration] = useState(0);
    const [showTooltip, setShowTooltip] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isImageUploading, setIsImageUploading] = useState(false);
    const [decryptedUserId, setDecryptedUserId] = useState(null);
    const [decryptedEmail, setDecryptedEmail] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [sessionExpiredMessage, setSessionExpiredMessage] = useState("");
    const token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token")
    const [uploadedPdf, setUploadedPdf] = useState(null);
    const [pdfurl, setPdfurl] = useState(null)
    const [worker, setWorker] = useState(null);
    const [isTextMode, setIsTextMode] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const [progress, setProgress] = useState(0)
    const [text, setText] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const recognitionRef = useRef(null);

    const [scale, setScale] = useState(0.4);
    const containerRef = useRef(null);
    const [isMediaEnded, setIsMediaEnded] = useState(false);
    const [showCreateAgentForm, setShowCreateAgentForm] = useState(false);
    const [authFromUrl, setAuthFromUrl] = useState(() => {
        return localStorage.getItem("auth_source") === "url";
    });
    const [requestIdFromCrossbar, setRequestIdFromCrossbar] = useState(null);
    const [idleVideoUrl, setIdleVideoUrl] = useState(null);
    const [isPlayingResponse, setIsPlayingResponse] = useState(false);

    const [waitingText, setWaitingText] = useState(null);
    const isSmallScreen = window.innerWidth < 768;
    const [companionStatus, setCompanionStatus] = useState(() => {
        const stored = localStorage.getItem('companionAppInstalled');
        return {
            isInstalled: stored === 'true',
            isRunning: false,
            showUI: false,
            lastChecked: null
        };
    });

    const [showNotification, setShowNotification] = useState(false);





    useEffect(() => {
        if (agentName) {
            let matchedAgent = allAgents.find(agent => agent.name === agentName);

            if (!matchedAgent) {
                matchedAgent = items.find(item => item.name === agentName);
            }

            if (matchedAgent) {
                if (!currentAgent || currentAgent.prompt_id !== matchedAgent.prompt_id) {

                    if (currentAgent?.prompt_id && messages.length > 0) {
                        console.log(`💾 Saving ${messages.length} messages for agent: ${currentAgent.name}`);
                        saveMessagesToStorage(messages, currentAgent.prompt_id);
                    }

                    console.log(`🧹 Clearing messages for agent switch to: ${matchedAgent.name}`);
                    setMessages([]);

                    // 3. Set the new agent
                    setCurrentAgent(matchedAgent);

                    setTimeout(() => {
                        const savedMessages = loadMessagesFromStorage(matchedAgent.prompt_id);
                        console.log(`📥 Loading ${savedMessages.length} messages for agent: ${matchedAgent.name}`);
                        setMessages(savedMessages);
                    }, 100);

                    // 5. Set idle video
                    if (matchedAgent.fillers) {
                        const idleFiller = matchedAgent.fillers.find(filler => filler.type === 'idle');
                        if (idleFiller?.video_link) {
                            setIdleVideoUrl(idleFiller.video_link);
                            setVideoUrl(idleFiller.video_link);
                        }
                    }
                }
            }
        }
    }, [allAgents, agentName]);

    const handleCreateAgentSubmit = async (agentDatafromApi) => {
        try {
            console.log("1. Agent data received:", agentDatafromApi);

            if (currentAgent?.prompt_id && messages.length > 0) {
                console.log(`💾 Saving ${messages.length} messages before creating new agent`);
                saveMessagesToStorage(messages, currentAgent.prompt_id);
            }

            console.log(`🧹 Clearing messages for new agent: ${agentDatafromApi.name}`);
            setMessages([]);

            setAllAgents(prevAgents => {
                const newAgents = [...prevAgents, agentDatafromApi];
                console.log("Updated allAgents:", newAgents.length);
                return newAgents;
            });

            // 4. Set new agent
            setCurrentAgent(agentDatafromApi);

            // 5. Set idle video if available
            if (agentDatafromApi.fillers) {
                const idleFiller = agentDatafromApi.fillers.find(filler => filler.type === 'idle');
                if (idleFiller?.video_link) {
                    setIdleVideoUrl(idleFiller.video_link);
                    setVideoUrl(idleFiller.video_link);
                }
            }

            setShowCreateAgentForm(false);
            const encodedName = encodeURIComponent(agentDatafromApi.name);
            navigate(`/agents/${encodedName}`);

            console.log(`✨ New agent created with fresh chat: ${agentDatafromApi.name}`);

        } catch (error) {
            console.error("Error creating agent:", error);
        }
    };

    useEffect(() => {
        return () => {
            // Save messages when component unmounts
            if (currentAgent?.prompt_id && messages.length > 0) {
                console.log(`💾 Component unmount: Saving ${messages.length} messages for ${currentAgent.name}`);
                saveMessagesToStorage(messages, currentAgent.prompt_id);
            }
        };
    }, []);


    useEffect(() => {
        console.log("Current agent changed:", currentAgent || 'None');
    }, [currentAgent]);

    useEffect(() => {
        console.log("AllAgents array updated, length:", allAgents.length);
    }, [allAgents]);
    useEffect(() => {
        // Set initial agent data
        if (agentData) {
            setCurrentAgent(agentData);
            // Set video URL from initial agent data if available
            if (agentData.fillers) {
                const idleFiller = agentData.fillers.find(filler => filler.type === 'idle');
                if (idleFiller?.video_link) {
                    console.log(idleFiller.video_link, 'idleFiller.video_link');
                    setVideoUrl(idleFiller.video_link);
                    setIdleVideoUrl(idleFiller.video_link);
                }
            }
        }



        const fetchPrompts = async () => {
            try {
                let allAgents = [];

                const publicResponse = await axios.get("https://mailer.hertzai.com/getprompt_all/");
                allAgents = publicResponse.data || [];
                console.log("Fetched public agents:", allAgents.length);

                if (decryptedUserId) {
                    try {
                        const userResponse = await axios.get(`https://mailer.hertzai.com/getprompt_userid/?user_id=${decryptedUserId}`);
                        const userAgents = userResponse.data || [];
                        console.log("Fetched user agents:", userAgents.length);

                        // 3. Add user agents that don't exist in public agents
                        userAgents.forEach(userAgent => {
                            const exists = allAgents.some(agent =>
                                agent.prompt_id === userAgent.prompt_id
                            );
                            if (!exists) {
                                allAgents.push(userAgent);
                            }
                        });
                    } catch (userError) {
                        console.warn("Failed to fetch user agents, continuing with public agents only:", userError);
                    }
                }

                console.log("Total merged agents:", allAgents.length);
                setAllAgents(allAgents);

            } catch (error) {
                console.error("Error fetching agents:", error);
                setAllAgents([]);
            }
        };
        fetchPrompts();
    }, [agentData, decryptedUserId]);



    useEffect(() => {
        const getUrlParams = () => {
            const searchParams = new URLSearchParams(window.location.search);
            const params = {
                agentName: searchParams.get('agent_name')?.trim(),
                token: searchParams.get('token')?.trim(),
                userId: searchParams.get('userid')?.trim(),
                email: searchParams.get('email')?.trim(),
                isTextMode: searchParams.get('text_mode')?.trim() === 'true' || false,
            };
            console.log("[Debug]: Extracted URL params:", params);
            return params;
        };

        const encryptValue = (value) => {
            try {
                if (!value || !SECRET_KEY) {
                    console.warn("[Encryption Warning]: Missing value or SECRET_KEY");
                    return null;
                }
                const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
                console.log("[Encryption]: Value encrypted successfully");
                return encrypted;
            } catch (error) {
                console.error("[Encryption Error]: Failed to encrypt value", error);
                return null;
            }
        };

        const storeEncryptedItem = (key, value) => {
            try {
                const encrypted = encryptValue(value);
                if (encrypted) {
                    localStorage.setItem(key, encrypted);
                    console.log(`[LocalStorage]: Set ${key} =`, encrypted);
                    return true;
                } else {
                    console.warn(`[LocalStorage Warning]: Encrypted value for ${key} is null`);
                }
            } catch (error) {
                console.error(`[LocalStorage Error]: Failed to store ${key}`, error);
            }
            return false;
        };

        const params = getUrlParams();
        let paramsFound = false;

        if (params.token) {
            try {
                localStorage.setItem("access_token", params.token);
                console.log("[Auth]: Token stored:", params.token);
                paramsFound = true;
            } catch (error) {
                console.error("[Token Error]: Failed to store access token", error);
            }
        } else {
            console.warn("[Auth Warning]: No token found in URL");
        }

        if (params.userId) {
            console.log("[UserID]: Found userId in URL:", params.userId);
            if (storeEncryptedItem("user_id", params.userId)) {
                paramsFound = true;
            }
        } else {
            console.warn("[UserID Warning]: No userId found in URL");
        }

        if (params.email) {
            console.log("[Email]: Found email in URL:", params.email);
            if (storeEncryptedItem("email_address", params.email)) {
                paramsFound = true;
            }
        } else {
            console.warn("[Email Warning]: No email found in URL");
        }
        if (params.isTextMode) {
            setIsTextMode(true);
            console.log("[Text Mode]: Text mode enabled from URL");
        }
        if (paramsFound) {
            setDecryptedUserId(params.userId || '');
            setDecryptedEmail(params.email || '');
            localStorage.setItem("auth_source", "url");
            setAuthFromUrl(true);

            console.log("[Auth Source]: Authentication data set from URL parameters");
        } else {
            console.log("[Init]: No URL parameters found for authentication.");
        }
    }, []);







    useEffect(() => {
        const adjustScale = () => {
            if (containerRef.current) {
                const containerHeight = containerRef.current.clientHeight;
                // Adjust scale to fit the page within the container height
                const targetHeight = containerHeight * 0.95; // 95% of container height to add some padding
                setScale(targetHeight / 842); // 842px is A4 default height
            }
        };

        adjustScale();
        window.addEventListener("resize", adjustScale);
        return () => window.removeEventListener("resize", adjustScale);
    }, [scale]);
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    const getChatStorageKey = (promptId) => {
        return `chat_messages_${promptId}`;
    };

    const saveMessagesToStorage = (messages, promptId) => {
        if (!promptId) return;

        try {
            const storageKey = getChatStorageKey(promptId);
            const chatData = {
                agentId: promptId,
                agentName: currentAgent?.name,
                lastUpdated: new Date().toISOString(),
                messageCount: messages.length,
                messages: messages
            };
            localStorage.setItem(storageKey, JSON.stringify(chatData));
            console.log(`💾 Saved ${messages.length} messages for agent ${promptId}`);
        } catch (error) {
            console.error('Failed to save messages to localStorage:', error);
        }
    };

    const loadMessagesFromStorage = (promptId) => {
        if (!promptId) return [];

        try {
            const storageKey = getChatStorageKey(promptId);
            const savedData = localStorage.getItem(storageKey);

            if (savedData) {
                const chatData = JSON.parse(savedData);
                // Handle both old format (just array) and new format (with metadata)
                const messages = Array.isArray(chatData) ? chatData : chatData.messages || [];
                console.log(`📥 Loaded ${messages.length} messages for agent ${promptId}`);
                return messages;
            }
        } catch (error) {
            console.error('Failed to load messages from localStorage:', error);
        }

        return [];
    };


    const getVideoWidth = () => {
        if (screenWidth <= 360) return "60%";
        if (screenWidth < 500) return "80%";
        if (screenWidth >= 500 && screenWidth <= 768) return "60%";
        if (screenWidth >= 2001) return 500;
        if (screenWidth >= 1861) return 460;
        if (screenWidth >= 1751) return 440;
        if (screenWidth >= 1651) return 420;
        if (screenWidth >= 1551) return 400;
        if (screenWidth >= 1451) return 380;
        if (screenWidth >= 1351) return 360;
        if (screenWidth >= 1251) return 340;
        if (screenWidth >= 1151) return 320;
        if (screenWidth >= 1051) return 300;
        if (screenWidth >= 951) return 280;
        return 260; // Default case for width <= 950px
    };


    const toggleTextMode = () => {
        setIsTextMode(prev => {
            const newTextMode = !prev;

            // If switching to text mode, stop any current media
            if (newTextMode) {
                if (videoRef.current) {
                    videoRef.current.pause();
                    videoRef.current.currentTime = 0;
                }
                if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                }
                setVideoUrl(null);
                setAudioUrl(null);
                setIsPlayingResponse(false);
            } else {
                if (idleVideoUrl) {
                    setVideoUrl(idleVideoUrl);
                }
            }

            return newTextMode;
        });
    };

    const handleCreateAgentClick = () => {
        if (!decryptedUserId || !token) {
            setIsModalOpen(true);
            return;
        }
        setShowCreateAgentForm(true);
    };
    const handleAgentSelect = (agent) => {
        setShowAgentsOverlay(false);

        if (agent && agent.prompt_id !== currentAgent?.prompt_id) {
            // 1. Save current messages before switching
            if (currentAgent?.prompt_id && messages.length > 0) {
                console.log(`💾 Saving ${messages.length} messages before selecting ${agent.name}`);
                saveMessagesToStorage(messages, currentAgent.prompt_id);
            }

            // 2. IMMEDIATELY clear messages
            console.log(`🧹 Clearing messages for agent selection: ${agent.name}`);
            setMessages([]);

            // 3. Call handleButtonClick which will handle the rest
            setTimeout(() => {
                handleButtonClick(agent);
            }, 50);
        }
    };

    const handleDataReceived = useCallback((data) => {
        console.log('🚦 handleDataReceived START');
        console.log('📥 Raw data:', data);

        try {
            let parsed;

            if (data.data) {
                if (typeof data.data === 'string') {
                    parsed = JSON.parse(data.data);
                } else {
                    parsed = data.data;
                }
            } else {
                parsed = data;
            }

            // Check for THINKING mode
            if (Number(parsed.priority) === 49 && parsed.action === 'Thinking') {
                console.log('🧠 THINKING MODE DETECTED');

                const thinkingText = parsed.text?.[0] || '';
                const requestId = parsed.request_id || 'unknown';

                // Create a unique ID for each individual thinking step
                const uniqueThinkingId = `thinking_step_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

                // Set start time if this is the first thinking message for this request
                if (!thinkingStartTime) {
                    setThinkingStartTime(new Date());
                }

                setMessages(prev => {
                    // Find the last user message to determine which thinking container this belongs to
                    const lastUserMessageIndex = prev.map((msg, index) => ({ msg, index }))
                        .reverse()
                        .find(({ msg }) => msg.type === 'user')?.index;

                    if (lastUserMessageIndex === undefined) {
                        console.warn('No user message found for thinking step');
                        return prev;
                    }

                    // Create a unique container ID based on the last user message position and request ID
                    const containerRequestId = `${requestId}_after_user_${lastUserMessageIndex}`;

                    // Check if we already have a thinking container for this specific user message
                    const existingContainerIndex = prev.findIndex(
                        (msg, index) =>
                            msg.type === 'thinking_container' &&
                            msg.containerRequestId === containerRequestId &&
                            index > lastUserMessageIndex // Container must be after the user message
                    );

                    if (existingContainerIndex >= 0) {
                        // Add to existing thinking container for this user message
                        const updated = [...prev];
                        const newThinkingStep = {
                            id: uniqueThinkingId,
                            content: thinkingText,
                            timestamp: new Date(),
                            lastUpdated: new Date(),
                            isExpanded: false,
                            isCompleted: false,
                            duration: null
                        };

                        updated[existingContainerIndex] = {
                            ...updated[existingContainerIndex],
                            thinkingSteps: [...updated[existingContainerIndex].thinkingSteps, newThinkingStep],
                            lastUpdated: new Date()
                        };

                        return updated;
                    } else {
                        // Create new thinking container for this user message
                        const newThinkingContainer = {
                            type: 'thinking_container',
                            id: `thinking_container_${containerRequestId}`,
                            requestId: requestId,
                            containerRequestId: containerRequestId, // New field to track which user message this belongs to
                            userMessageIndex: lastUserMessageIndex, // Track which user message this thinking is for
                            timestamp: new Date(),
                            lastUpdated: new Date(),
                            isMainExpanded: false,
                            isCompleted: false,
                            totalDuration: null,
                            thinkingSteps: [{
                                id: uniqueThinkingId,
                                content: thinkingText,
                                timestamp: new Date(),
                                lastUpdated: new Date(),
                                isExpanded: false,
                                isCompleted: false,
                                duration: null
                            }]
                        };

                        return [...prev, newThinkingContainer];
                    }
                });

                setCurrentThinkingId(containerRequestId);
                setLoading(false);
                return;
            }

            // Handle regular responses
            const extractedText = parsed.text?.[0] || '';
            const responseVideoUrl = parsed.video_link?.video || '';
            const responseAudioUrl = parsed.video_link?.aud_url || '';

            // Calculate duration and mark thinking as completed when we get the final response
            if (extractedText || responseVideoUrl || responseAudioUrl) {
                const endTime = new Date();
                const duration = thinkingStartTime ? (endTime - thinkingStartTime) / 1000 : 0;

                // Mark the thinking container and all its steps as completed
                if (currentThinkingId) {
                    setMessages(prev =>
                        prev.map(msg => {
                            if (msg.type === 'thinking_container' && msg.containerRequestId === currentThinkingId && !msg.isCompleted) {
                                return {
                                    ...msg,
                                    isCompleted: true,
                                    totalDuration: duration,
                                    completedAt: endTime,
                                    thinkingSteps: msg.thinkingSteps.map(step => ({
                                        ...step,
                                        isCompleted: true,
                                        duration: duration / msg.thinkingSteps.length // Distribute duration evenly
                                    }))
                                };
                            }
                            return msg;
                        })
                    );
                }

                setCurrentThinkingId(null);
                setThinkingStartTime(null);
            }

            // Handle text mode
            if (isTextMode) {
                if (extractedText) {
                    const assistantMessage = {
                        type: "assistant",
                        content: extractedText,
                    };
                    setMessages(prev => [...prev, assistantMessage]);
                    setLoading(false);
                }

                if (data.page_image_url) {
                    setUploadedImage(data.page_image_url);
                }
                return;
            }

            // Handle media mode
            const hasText = !!extractedText;
            const hasAudio = !!(responseAudioUrl || responseVideoUrl);
            const hasWaitingText = !!waitingText;

            if (hasText && !hasAudio) {
                setWaitingText(extractedText);
                setLoading(false);
                return;
            }

            if (hasAudio) {
                let textToShow = hasWaitingText ? waitingText : hasText ? extractedText : null;

                if (textToShow) {
                    const assistantMessage = {
                        type: "assistant",
                        content: textToShow,
                    };
                    setMessages(prev => [...prev, assistantMessage]);
                    setWaitingText(null);
                }

                setVideoUrl(responseVideoUrl);
                setAudioUrl(responseAudioUrl);
                setIsPlayingResponse(true);
                setLoading(false);
            }

            if (data.page_image_url) {
                setUploadedImage(data.page_image_url);
            }

        } catch (err) {
            console.error('❌ Error processing data:', err);
            setLoading(false);
        }
    }, [isTextMode, waitingText, thinkingStartTime, currentThinkingId]);

    useEffect(() => {
        console.log('🎯 currentThinkingId changed:', currentThinkingId);
    }, [currentThinkingId]);


    useEffect(() => {
        console.log('📝 thinkingMessages1 changed:', messages);
    }, [messages]);

    useEffect(() => {
        let payload = {
            agentname: currentAgent?.name,
            email: decryptedEmail,
            access_token: token,
            user_id: decryptedUserId
        }
        if (companionStatus.isRunning) {
            const sendPostRequest = async () => {
                try {
                    const response = await axios.post('http://localhost:5000/api/storage/set', payload); //this is for setting the value in companion app

                    // Access response data
                    console.log('POST request response:', response.data);


                } catch (error) {
                    console.error('Failed to send POST request:', error);
                }
            };

            sendPostRequest();
        }
    }, [companionStatus.isRunning, currentAgent?.name, decryptedEmail, token, decryptedUserId]);




    useEffect(() => {
        let activeWorker = null;

        const initializeWorker = () => {
            try {
                const crossbarWorker = new Worker(
                    new URL('./crossbarWorker.js', import.meta.url),
                    { type: 'module' }
                );

                crossbarWorker.onmessage = (e) => {
                    const { type, payload } = e.data;
                    const timestamp = new Date().toLocaleTimeString();

                    // Log all messages with timestamp
                    console.log(`[${timestamp}] ${type}:`, payload);

                    switch (type) {
                        case 'CONNECTION_STATUS':
                            console.log(`🔌 Connection status: ${payload}`);
                            setConnectionStatus(payload);
                            break;

                        case 'PROGRESS_UPDATE':
                            console.log(`📊 Progress: ${payload}%`);
                            setProgress(payload);
                            break;

                        case 'DATA_RECEIVED':
                            handleDataReceived(payload);
                            break;

                        case 'LOG':
                            // For detailed worker logs
                            console.log(`🔍 Worker log (${payload.type}):`, payload.data);
                            break;

                        case 'ERROR':
                            console.error(`❌ Error:`, payload);
                            break;
                        case 'COMPANION_STATUS_UPDATE':
                            console.log(`🔧 Companion app status:`, payload);

                            // Check localStorage first - preserve installation status if it says true
                            const storedInstallationStatus = localStorage.getItem('companionAppInstalled') === 'true';

                            // Only update localStorage when app is confirmed installed and not already stored
                            if (payload.isInstalled && !storedInstallationStatus) {
                                localStorage.setItem('companionAppInstalled', 'true');
                            }

                            // Enhanced update with change detection logging
                            setCompanionStatus(prevStatus => {
                                // Preserve localStorage installation status if it exists and is true
                                const finalInstallationStatus = storedInstallationStatus || payload.isInstalled;

                                const newStatus = {
                                    isInstalled: finalInstallationStatus,
                                    isRunning: payload.isRunning,
                                    showUI: payload.showUI === true,
                                    lastChecked: new Date().toISOString()
                                };

                                // ONLY show notification when it's from an action request (not periodic checks)
                                if (payload.showUI && payload.fromActionRequest) {
                                    console.log('🔔 Showing companion status notification due to action request');
                                    setShowNotification(true);

                                    // Hide notification after 6 seconds
                                    setTimeout(() => {
                                        setShowNotification(false);
                                    }, 6000);
                                }

                                // Always log status changes for debugging (this helps you see real-time status)
                                if (prevStatus.isInstalled !== newStatus.isInstalled ||
                                    prevStatus.isRunning !== newStatus.isRunning) {
                                    console.log('🔄 Companion status changed:', {
                                        from: { installed: prevStatus.isInstalled, running: prevStatus.isRunning },
                                        to: { installed: newStatus.isInstalled, running: newStatus.isRunning },
                                        fromActionRequest: payload.fromActionRequest
                                    });
                                }

                                return newStatus;
                            });
                            break;

                        // 
                        case 'UPDATE_LOCAL_STORAGE':
                            // Handle localStorage updates from worker
                            localStorage.setItem(payload.key, payload.value);
                            console.log(`📦 localStorage updated: ${payload.key} = ${payload.value}`);
                            break;

                        default:
                            console.log(`⚠️ Unknown worker message type: ${type}`);
                            break;
                    }
                };

                activeWorker = crossbarWorker;
                setWorker(crossbarWorker);

                if (decryptedUserId) {
                    console.log('🚀 Initializing worker with user ID:', decryptedUserId, requestId);
                    crossbarWorker.postMessage({
                        type: 'INIT',
                        payload: {
                            wsUri: "wss://aws_rasa.hertzai.com:8445/wss",
                            userId: decryptedUserId,
                            maxRetries: 8,
                            retryDelay: 5000
                        }
                    });
                }

            } catch (error) {
                console.error('❌ Worker initialization error:', error);
                setConnectionStatus('Failed to Initialize');
            }
        };

        initializeWorker();

        return () => {
            if (activeWorker) {
                console.log(activeWorker, 'activeWorker');
                console.log('👋 Cleaning up worker');
                activeWorker.postMessage({ type: 'CLOSE' });
                activeWorker.terminate();
            }
        };
    }, [decryptedUserId, handleDataReceived, currentAgent]);
    useEffect(() => {
        // Only send the requestId to the worker when it changes and is not null
        if (requestId && worker) {
            console.log('📋 Sending request ID to worker:', requestId);
            setRequestIdFromCrossbar(requestId);
            worker.postMessage({
                type: 'SET_REQUEST_ID',
                payload: {
                    request_Id: requestId
                }
            });
        }
    }, [requestId, worker]);
    useEffect(() => {
        // Function to decrypt the values
        const decryptValue = (encryptedValue) => {
            try {
                const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
                const originalValue = bytes.toString(CryptoJS.enc.Utf8);
                return originalValue;
            } catch (error) {
                console.error("Failed to decrypt value:", error);
                return null;
            }
        };


        const encryptedUserId = localStorage.getItem("user_id");
        const encryptedEmail = localStorage.getItem("email_address");

        if (encryptedUserId && encryptedEmail) {
            const userId = decryptValue(encryptedUserId);
            const email = decryptValue(encryptedEmail);

            setDecryptedUserId(userId);
            setDecryptedEmail(email);


        } else {
            console.warn("No userId or email found in localStorage.");
        }
    }, [decryptedEmail, decryptedUserId]);
    const isIdleVideo = (videoUrl) => {
        return videoUrl === idleVideoUrl;
    };



    const handleMediaEnded = () => {
        try {
            console.log('🎬 Media ended, returning to idle video');
            setIsPlayingResponse(false);

            // Use the stored idle video URL
            if (idleVideoUrl) {
                setVideoUrl(idleVideoUrl);
                setAudioUrl(null); // Clear audio when returning to idle

                setTimeout(() => {
                    if (videoRef.current) {
                        videoRef.current.src = idleVideoUrl;
                        videoRef.current.load();
                    }
                }, 500);
            } else {
                // Fallback: try to find idle video from current agent
                const idleVideo = currentAgent?.fillers?.find(filler => filler.type === "idle") ||
                    agentData?.fillers?.find(filler => filler.type === "idle");

                if (idleVideo?.video_link) {
                    setIdleVideoUrl(idleVideo.video_link); // Store for future use
                    setVideoUrl(idleVideo.video_link);
                    setAudioUrl(null);

                    setTimeout(() => {
                        if (videoRef.current) {
                            videoRef.current.src = idleVideo.video_link;
                            videoRef.current.load();
                        }
                    }, 500);
                } else {
                    console.warn("Idle video not found in agent fillers.");
                }
            }
        } catch (error) {
            console.error("Error handling media end:", error);
        }
    };


    const handleButtonClick = (chat) => {
        setCurrentAgent(chat);
        if (chat && chat.prompt_id !== currentAgent?.prompt_id) {

            if (currentAgent?.prompt_id && messages.length > 0) {
                console.log(`💾 Saving ${messages.length} messages before switching to ${chat.name}`);
                saveMessagesToStorage(messages, currentAgent.prompt_id);
            }

            // 2. IMMEDIATELY clear messages
            console.log(`🧹 Clearing messages for agent switch to: ${chat.name}`);
            setMessages([]);

            // 3. Set video and agent
            const idleFiller = chat.fillers?.find(filler => filler.type === 'idle');
            setVideoUrl(idleFiller?.video_link);
            setCurrentAgent(chat);

            // 4. Load new agent's messages after a brief delay
            setTimeout(() => {
                const savedMessages = loadMessagesFromStorage(chat.prompt_id);
                console.log(`📥 Loading ${savedMessages.length} messages for agent: ${chat.name}`);
                setMessages(savedMessages);
            }, 100);

            setIsOpen(false);
            navigate(`/agents/${encodeURIComponent(chat.name)}`);
        } else {
            console.log("Same agent or agent not found");
        }
    };











    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };




    useEffect(() => {
        scrollToBottom();
    }, [messages, loading]);
    const handlePlay = async () => {
        if (isTextMode) {
            console.log('Text mode is enabled, skipping video playback');
            return;
        }

        if (videoRef.current) {
            try {
                if (videoRef.current.readyState >= 2) {
                    await videoRef.current.play();
                } else {
                    videoRef.current.addEventListener('canplay', async () => {
                        try {
                            await videoRef.current.play();
                        } catch (err) {
                            console.error("Video play failed after canplay:", err);
                        }
                    }, { once: true });
                }
            } catch (error) {
                console.error("Video playback failed:", error);
            }
        }
    };



    const TextModeToggle = () => (
        <button
            onClick={toggleTextMode}
            className={`flex items-center gap-2 px-3 py-1 rounded-lg transition-colors ${isTextMode
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
            title={isTextMode ? "Disable Text Mode" : "Enable Text Mode"}
        >
            <FileText className="w-4 h-4" />
            <span className="text-sm">
                {isTextMode ? "Text Mode" : "Media Mode"}
            </span>
        </button>
    );



    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setCurrentPage(1);
    };

    const nextPage = () => setCurrentPage((prev) => (prev < numPages ? prev + 1 : prev));
    const prevPage = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));


    const handleStart = () => {
        const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!SpeechRecognition) {
            alert('Speech Recognition is not supported in your browser.');
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = 'en-US';

        recognition.onresult = (event) => {
            let transcript = '';
            for (let i = event.resultIndex; i < event.results.length; ++i) {
                transcript += event.results[i][0].transcript;
            }
            setInputMessage((prev) => prev + transcript);
        };

        recognition.onerror = (event) => {
            console.error('Speech recognition error', event.error);
        };

        recognition.onend = () => {
            setIsRecording(false);
        };

        recognition.start();
        recognitionRef.current = recognition;
        setIsRecording(true);
    };

    const handleStop = () => {
        recognitionRef.current?.stop();
        setIsRecording(false);
    };








    const handleLoadedMetadata = (event) => {
        if (videoRef.current) {
            setDuration(videoRef.current.duration);
            handlePlay();
        }
    };
    const handleLoadedMetadataaudio = (event) => {
        const duration = event.target.duration;
        setDuration(duration);
    };
    const handlePdfSelect = async (event) => {
        const file = event.target.files[0];

        if (!file) {
            console.error("No file selected.");
            return;
        }
        if (file && file.type === 'application/pdf') {
            const previewUrl = URL.createObjectURL(file);
            setPdfurl(previewUrl);
        }

        try {
            // Set the selected PDF file
            setPdfFile(file);


            var formdata = new FormData();
            formdata.append("bot_type", "book_parsing");
            formdata.append("user_id", decryptedUserId);
            formdata.append("request_id", uuidv4());
            formdata.append("file", file, file.name);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            };

            fetch("https://azurekong.hertzai.com:8443/book_parsing/book_parsing_upload_api", requestOptions)
                .then(async (response) => {
                    if (!response.ok) {
                        console.error("Failed to upload PDF:", response.status, response.statusText);
                        return;
                    }

                    const result = await response.json();
                    setRequestId(result.request_id)

                    setpdfFileUrl(result.file_url);
                    // setUploadedPdf(result.file_url);
                })
                .catch(error => {
                    console.error('Error during PDF upload process:', error);
                });
        } catch (error) {
            console.error("Error during PDF upload process:", error);
        }
    };






    const handleRemovePdf = () => {
        setPdfFile(null);
        setpdfFileUrl(null);
    };

    const handleImageSelect = async (event) => {
        const file = event.target.files[0];

        if (file) {
            setIsImageUploading(true);
            setUserImage(URL.createObjectURL(file));

            const formData = new FormData();
            formData.append("user_id", decryptedUserId);
            formData.append("file", file, file.name);
            formData.append("request_id", uuidv4());

            try {
                const response = await fetch(
                    "https://azurekong.hertzai.com:8443/makeit/upload_file",
                    {
                        method: "POST",
                        body: formData,
                        redirect: "follow",
                    }
                );

                if (response.ok) {
                    const result = await response.json();
                    setUserImage(result.file_url);
                } else {
                    console.error(
                        "Failed to upload image:",
                        response.status,
                        response.statusText
                    );
                }
            } catch (error) {
                console.error("Error uploading image:", error);
            } finally {
                setIsImageUploading(false);
            }
        }
    };






    const handleRemoveImage = () => {
        setUserImage(null);
        setSelectedFile(null);
        setFileUrl(null);
    };


    const LogOutUser = () => {

        localStorage.removeItem("access_token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("email_address");
        navigate('/')

    };


    const handleFocus = () => {
        if (!token) {
            setShowTooltip(true);
        }
    };

    const handleBlur = () => {
        setShowTooltip(false);
    };

    const handleSend = async () => {
        const origin = window.location.origin.toLowerCase();
        const pathname = window.location.pathname.toLowerCase();

        console.log(origin, pathname, 'origin and pathname');

        const generatedRequestId = requestId || uuidv4();
        setRequestId(generatedRequestId);

        setCurrentThinkingId(null);
        setThinkingStartTime(null);

        const isPersonalisedEndpoint =
            (origin === 'https://hertzai.com' && (pathname === '/' || pathname === '')) ||
            pathname.includes('hevolve') ||
            pathname.includes('personalised');

        console.log(isPersonalisedEndpoint, 'isPersonalisedEndpoint');

        if (!inputMessage.trim() && !fileUrl && !userImage) return;

        const userMessage = {
            type: "user",
            content: inputMessage,
            pdf: pdffileUrl || null,
            image: userImage || null
        };

        // Only add user message to chat
        setMessages((prevMessages) => [...prevMessages, userMessage]);
        setLoading(true);

        // Clear any waiting text when sending new message
        setWaitingText(null);
        console.log('agentdata', agentData)
        console.log('currentagent', currentAgent)

        const dataToSend = JSON.stringify({
            text: inputMessage,
            user_id: decryptedUserId,
            teacher_avatar_id: agentData?.teacher_avatar_id || null,
            conversation_id: uuidv4(),
            request_id: generatedRequestId,
            prompt_id: isPersonalisedEndpoint ? null : currentAgent?.prompt_id || null,
            bot_type: currentAgent?.name || '',
        });

        // Clear form data
        setUploadedPdf(null);
        setUserImage(null);
        setInputMessage("");
        setFileUrl(null);
        setPdfFile(null);
        setpdfFileUrl(null);

        if (textareaRef.current) {
            textareaRef.current.style.height = "70px";
            textareaRef.current.style.overflowY = "hidden";
        }

        try {
            if (!token) {
                console.error("Authorization token is missing.");
                setLoading(false);
                setIsModalOpen(true);
                return;
            }

            const endpoint = isPersonalisedEndpoint
                ? configData.personalisedLearningAgent
                : configData.forAllAgents;

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: dataToSend,
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                console.error("API call failed:", response.status, response.statusText);

                if (response.status === 401) {
                    if (!refresh_token) {
                        console.warn("Session expired. No refresh token available.");
                        setSessionExpiredMessage("Session expired. Please log in again.");
                        setIsModalOpen(true);
                        setLoading(false);
                        return;
                    }
                }

                if (
                    errorResponse.error === "invalid_token" ||
                    errorResponse.error_description === "The access token is invalid or has expired"
                ) {
                    console.warn("Access token expired. Removing stored data and opening login modal...");
                    localStorage.removeItem('expire_token');
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user_id');
                    localStorage.removeItem('email_address');
                    setIsModalOpen(true);
                    setLoading(false);
                }
                return;
            }

            const dataJson = await response.json();

            if (dataJson.status === "no_content") {
                console.log("No content from API. Awaiting Crossbar message...");
                return;
            }

            console.log("✅ API Response received successfully");
            console.log("📋 Request ID:", dataJson.request_id);
            console.log("🔄 Response will be handled by WebSocket/Crossbar via handleDataReceived");


            setUserImage(null);

        } catch (err) {
            console.error("Unexpected error during request:", err);
            setLoading(false);
        }

        setPdfFile(null);
    };

    const handleImageClick = (imageUrl) => {
        setUploadedImage(imageUrl);
    };
    const handlePdfClick = (pdfUrl) => {
        console.log(pdfUrl)
        setUploadedPdf(pdfurl);
    };










    const closePreview = () => {
        setUploadedImage(null);
    };




    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const items = [

        {
            "prompt": "Your name is Radha, you are a sweet beautiful female .",
            "prompt_id": 54,
            "name": "Personalised Learning",
            "created_date": "2024-11-19T10:24:38",
            "request_id": "8b3e7d91-a49b-497d-8051-a3fa4ff3c53e",
            "is_public": true,
            "create_agent": false,
            "is_active": true,
            "user_id": 10077,
            "image_url": "http://aws_rasa.hertzai.com:5459/output/25dfe16e-a6a4-11ef-a097-42010aa00006.png",
            "teacher_avatar_id": 2759,
            "video_url": null,
            "video_text": "This is Static Description",
            "teacher_image_url": "https://azurekong.hertzai.com:8443/mkt-aws/txt/voice_dump/8f4c3958-9cropped_image.png",
            "description": "https://azurekong.hertzai.com:8443/mkt-azure/examples/74eaec428f4c3958-9cropped_image_pred_fls_f4203dae_bf375f78-eLily_audio_embed.mp4",
            "image_name": "8f4c3958-9cropped_image.png",
            "fillers": [
                {
                    "text": "Oops something went wrong",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-azure/examples/7293f99b8f4c3958-9cropped_image_pred_fls_289940eb_bf375f78-eLily_audio_embed.mp4",
                    "type": "internal_server_error"
                },
                {
                    "text": "",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-aws/examples/8f4c3958-9cropped_image_pred_fls_Blank_audio_embed.mp4",
                    "type": "idle"
                }
            ]
        },
        {
            "prompt_id": 49,
            "name": "Speech Therapy Agent",
            "prompt": "You are the great India itself,  you talk about greatness of India and Indiana and its diversity. ",
            "created_date": "2024-11-11T10:06:25",
            "request_id": "9ac457f0-eb8d-4869-9d24-4d445f6f6d66",
            "is_public": true,
            "create_agent": false,
            "is_active": true,
            "user_id": decryptedUserId,
            "image_url": "http://aws_rasa.hertzai.com:5459/output/32cbfdba-a17a-11ef-b355-42010aa00006.png",
            "teacher_avatar_id": 2739,
            "video_url": null,
            "video_text": "This is Static Description",
            "teacher_image_url": "https://azurekong.hertzai.com:8443/mkt-aws/txt/voice_dump/acb7ea45-0cropped_image.png",
            "description": "https://azurekong.hertzai.com:8443/mkt-azure/examples/ed5b3666acb7ea45-0cropped_image_pred_fls_a94bd0b3_2665af70-2Katie_audio_embed.mp4",
            "image_name": "acb7ea45-0cropped_image.png",
            "fillers": [
                {
                    "text": "Oops something went wrong",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-aws/examples/f6a8d897acb7ea45-0cropped_image_pred_fls_b4e1970c_2665af70-2Katie_audio_embed.mp4",
                    "type": "internal_server_error"
                },
                {
                    "text": "",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-aws/examples/acb7ea45-0cropped_image_pred_fls_Blank_audio_embed.mp4",
                    "type": "idle"
                }
            ]

        },
        {
            "prompt_id": 20,
            "name": "Spoken English Agent",
            "prompt": "talk as if you are my kid",
            "created_date": "2024-07-10T15:21:01",
            "request_id": "1c11d245-08f8-4e1a-9d2d-5c8128a0b185",
            "is_public": true,
            "create_agent": false,
            "is_active": true,
            "user_id": 10077,
            "image_url": "http://aws_rasa.hertzai.com:5459/output/cb7b4fe8-3ed8-11ef-becc-000d3af074c1.png",
            "teacher_avatar_id": 2193,
            "video_url": null,
            "video_text": "This is Static Description",
            "teacher_image_url": "https://azurekong.hertzai.com:8443/mkt-aws/txt/voice_dump/comfyinstant_89b6fbf1-2cropped2922730214132889043.png",
            "description": "https://azurekong.hertzai.com:8443/mkt-azure/examples/0b63bbb0comfyinstant_89b6fbf1-2cropped2922730214132889043_pred_fls_cc94d287_450f5ce5-3Margaret_audio_embed.mp4",
            "image_name": "comfyinstant_89b6fbf1-2cropped2922730214132889043.png",
            "fillers": [
                {
                    "text": "Oops something went wrong",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-azure/examples/5fffd4e3comfyinstant_89b6fbf1-2cropped2922730214132889043_pred_fls_4ad5022f_450f5ce5-3Margaret_audio_embed.mp4",
                    "type": "internal_server_error"
                },
                {
                    "text": "",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-azure/examples/comfyinstant_89b6fbf1-2cropped2922730214132889043_pred_fls_Blank_audio_embed.mp4",
                    "type": "idle"
                }
            ]
        }
        , {
            "prompt_id": 5,
            "name": "News Agent",
            "prompt": "You are a Teacher who responds as if you are Naruto",
            "created_date": "2024-02-08T10:46:49",
            "request_id": null,
            "is_public": true,
            "create_agent": false,
            "is_active": true,
            "user_id": 104,
            "image_url": "https://azurekong.hertzai.com:8443/mkt-azure/examples/bace4e36-0naruto.jpg",
            "teacher_avatar_id": 2759,
            "video_url": "https://azurekong.hertzai.com:8443/mkt-azure/examples/74eaec428f4c3958-9cropped_image_pred_fls_f4203dae_bf375f78-eLily_audio_embed.mp4",
            "video_text": "This is Static Description",
            "teacher_image_url": "https://azurekong.hertzai.com:8443/mkt-aws/txt/voice_dump/8f4c3958-9cropped_image.png",
            "description": "https://azurekong.hertzai.com:8443/mkt-azure/examples/74eaec428f4c3958-9cropped_image_pred_fls_f4203dae_bf375f78-eLily_audio_embed.mp4",
            "image_name": "8f4c3958-9cropped_image.png",
            "fillers": [
                {
                    "text": "Oops something went wrong",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-azure/examples/7293f99b8f4c3958-9cropped_image_pred_fls_289940eb_bf375f78-eLily_audio_embed.mp4",
                    "type": "internal_server_error"
                },
                {
                    "text": "",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-aws/examples/8f4c3958-9cropped_image_pred_fls_Blank_audio_embed.mp4",
                    "type": "idle"
                }
            ]
        },
        {
            "prompt_id": 12,
            "name": "Podcast Agent",
            "prompt": "create an alaram after an hour",
            "created_date": "2024-07-09T01:34:29",
            "request_id": "454dfsdfsdsfasf564545",
            "is_public": true,
            "create_agent": false,
            "is_active": true,
            "user_id": 10669,
            "image_url": "http://aws_rasa.hertzai.com:5459/output/8e891f44-96b6-11ef-a097-42010aa00006.png",
            "teacher_avatar_id": 1802,
            "video_url": null,
            "video_text": "This is Static Description",
            "teacher_image_url": "https://azurekong.hertzai.com:8443/mkt-aws/txt/voice_dump/27b62c6e-fcropped6488793763494973038.png",
            "description": "https://azurekong.hertzai.com:8443/mkt-azure/examples/77047ca627b62c6e-fcropped6488793763494973038_pred_fls_de571ca5_79b9078f-5Hindi_F_Tyagi_audio_embed.mp4",
            "image_name": "27b62c6e-fcropped6488793763494973038.png",
            "fillers": [
                {
                    "text": "",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-azure/examples/27b62c6e-fcropped6488793763494973038_pred_fls_Blank_audio_embed.mp4",
                    "type": "idle"
                }
            ]
        },
        {
            "prompt_id": 13,
            "name": "Story Narrator Agent",
            "prompt": "play music for 6 month old",
            "created_date": "2024-07-09T10:23:12",
            "request_id": "14417881-e4d8-467d-8201-b66552e48531",
            "is_public": true,
            "create_agent": false,
            "is_active": true,
            "user_id": 10676,
            "image_url": "http://aws_rasa.hertzai.com:5459/output/4b987996-96bb-11ef-a35b-42010aa00006.png",
            "teacher_avatar_id": 2141,
            "video_url": null,
            "video_text": "This is Static Description",
            "teacher_image_url": "https://azurekong.hertzai.com:8443/mkt-aws/txt/voice_dump/comfyinstant_235bda39-8cropped6966416360302249442.png",
            "description": "https://azurekong.hertzai.com:8443/mkt-azure/examples/43932170comfyinstant_235bda39-8cropped6966416360302249442_pred_fls_56c3e733__Abdul_Kalam-_English_Motivational_Speech_audio_embed.mp4",
            "image_name": "comfyinstant_235bda39-8cropped6966416360302249442.png",
            "fillers": [
                {
                    "text": "",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-azure/examples/comfyinstant_235bda39-8cropped6966416360302249442_pred_fls_Blank_audio_embed.mp4",
                    "type": "idle"
                }
            ]
        },
        {
            "prompt_id": 48,
            "name": "Casual Conversation Agent",
            "prompt": "Spoken English tutor",
            "created_date": "2024-11-11T10:06:26",
            "request_id": "6a65e893-644a-4049-8572-202172e50d00",
            "is_public": true,
            "create_agent": false,
            "is_active": true,
            "user_id": 10077,
            "image_url": "http://aws_rasa.hertzai.com:5459/output/8fc43ae2-a124-11ef-a35b-42010aa00006.png",
            "teacher_avatar_id": 2735,
            "video_url": null,
            "video_text": "This is Static Description",
            "teacher_image_url": "https://azurekong.hertzai.com:8443/mkt-aws/txt/voice_dump/cf9788e4-ccropped_image.png",
            "description": "https://azurekong.hertzai.com:8443/mkt-azure/examples/77a8e926cf9788e4-ccropped_image_pred_fls_a596bcb8_efe2bbf3-aLily_audio_embed.mp4",
            "image_name": "cf9788e4-ccropped_image.png",
            "fillers": [
                {
                    "text": "",
                    "video_link": "https://azurekong.hertzai.com:8443/mkt-azure/examples/cf9788e4-ccropped_image_pred_fls_Blank_audio_embed.mp4",
                    "type": "idle"
                }
            ]
        }



    ]
    const toggleContent = () => {
        setShowContent((prevState) => !prevState);
    };


    return (
        <>
            <div className="flex bg-black h-screen mb-6 overflow-hidden" >
                {screenWidth > 768 ? (
                    <div
                        onMouseEnter={toggleContent}
                        onMouseLeave={toggleContent}
                        className={`relative group w-[20%] sm:w-[30%] md:w-[15%] lg:w-[20%] text-gray-300 p-4 flex flex-col h-screen ${showContent ? "bg-gray-900" : ""}`}
                    >
                        <div className="flex justify-between items-center mb-4">
                            <h1 className="text-2xl font-semibold text-white">HevolveAI</h1>
                        </div>

                        <div className={`absolute left-0 w-full h-screen bg-gray-900 transition-opacity duration-300 ${showContent ? "opacity-100 top-4" : "opacity-0 top-0"}`}>
                            <div className="flex justify-between items-center mb-2">
                                <h1 className="text-2xl font-semibold text-white ml-4">HevolveAI</h1>
                            </div>

                            <button
                                onClick={handleCreateAgentClick}
                                className={`flex items-center gap-2 mb-1 ${(decryptedUserId && token)
                                    ? 'text-orange-500 hover:text-orange-600'
                                    : 'text-gray-500 hover:text-gray-400 cursor-not-allowed'
                                    }`}
                                title={(decryptedUserId && token) ? "Create new Agent" : "Please login to create an agent"}
                            >
                                <Plus className="w-4 h-4" />
                                <span>Create new Agent</span>
                                {!(decryptedUserId && token) && <span className="text-xs">(Login required)</span>}
                            </button>

                            <div className="mb-4 ml-4">
                                <h2 className="text-lg mb-2">Starred</h2>
                                <div className="text-sm text-gray-500 flex items-center gap-2">
                                    <Star className="w-4 h-4" />
                                    <span>Star chats you use often</span>
                                </div>
                            </div>

                            <div className="flex-1">
                                <h2 className="text-sm mb-2 ml-4">Recents</h2>
                                <div className="space-y-1">
                                    {items.map((chat, index) => (
                                        <div
                                            onClick={() => handleButtonClick(chat)}
                                            key={index}
                                            className="flex items-center ml-1 justify-start gap-1 hover:bg-gray-800 p-2 rounded cursor-pointer"
                                        >
                                            <img
                                                src={
                                                    chat.teacher_image_url || chat.image_url || AgentPoster
                                                }
                                                alt={chat?.name}
                                                className="md:w-6 md:h-6 lg:w-8 lg:h-8 rounded-full xl:w-8 xl:h-8"
                                            />
                                            <span className="truncate sm:text-base md:text-[1.2rem]">{chat?.name}</span>
                                        </div>
                                    ))}
                                </div>

                                <button onClick={() => setShowAgentsOverlay(true)} className="text-sm mt-2 ml-2 hover:text-white flex items-center gap-1">
                                    View All Agents
                                    <ChevronRight className="w-4 h-4" />
                                </button>
                                <button className="flex justify-center flex-col w-full items-center xl:flex-row xl:justify-around">
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.hertzai.hevolve&hl=en&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                                        className="inline-block"
                                    >
                                        <img
                                            alt="Get it on Google Play"
                                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                            className="w-32 h-12 object-contain"
                                        />
                                    </a>
                                    <a
                                        href="https://azurekong.hertzai.com:8443/mkt-aws/examples/0073b714-5HevolveAI_Agent_Companion_Setup_11_(1).exe"
                                        className="inline-block font-serif text-sm mb-4"
                                    >
                                        <img
                                            alt="Download HevolveAI Companion"
                                            src="/companion.svg"
                                            className="w-32 h-12 object-contain"
                                        />
                                    </a>
                                </button>

                                <div className="mt-auto space-y-4 absolute bottom-0">
                                    <div onClick={toggleDropdown} className="flex items-center gap-2 cursor-pointer mb-5">
                                        <button className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center">
                                            <span className="text-white">
                                                {decryptedEmail ? decryptedEmail.charAt(0).toUpperCase() : ''}
                                            </span>
                                        </button>
                                        <span className="text-sm truncate">
                                            {(decryptedEmail && token && decryptedUserId) ? decryptedEmail : "Welcome! Log in"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-auto space-y-4">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                    <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center">
                                        <span className="text-white">
                                            {decryptedEmail ? decryptedEmail.charAt(0).toUpperCase() : ''}
                                        </span>
                                    </div>
                                    <span className="text-sm truncate">
                                        {(decryptedEmail && token && decryptedUserId) ? decryptedEmail : "Welcome! Log in"}
                                    </span>
                                </div>
                                <ChevronRight className="w-4 h-4" />
                            </div>
                        </div>

                        {isOpen && (
                            <div
                                style={{ border: '1px solid gray' }}
                                className="absolute bottom-20 right-0 left-1 border-white w-64 bg-gray-900 text-white rounded-lg p-4 z-10"
                            >
                                {/* Email Section */}
                                <div className="flex items-center gap-2 mb-4 border-b border-gray-700 pb-2">
                                    <div className="bg-purple-500 text-white flex items-center justify-center w-8 h-8 rounded-full">
                                        R
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium">Personal</p>
                                        <p className="text-xs text-gray-400">Pro plan</p>
                                    </div>
                                </div>

                                {/* Options List */}
                                <ul className="space-y-2">
                                    <li onClick={() => navigate("/AboutHevolve")} className="cursor-pointer hover:bg-gray-800 p-2 rounded">
                                        About Hevolve
                                    </li>
                                    <li onClick={() => navigate("/agents")} className="cursor-pointer hover:bg-gray-800 p-2 rounded">
                                        Agents
                                    </li>
                                    <li onClick={() => navigate("/aboutus")} className="cursor-pointer hover:bg-gray-800 p-2 rounded">
                                        About Us
                                    </li>
                                    <li onClick={() => navigate('/Plan')} className="cursor-pointer hover:bg-gray-800 p-2 rounded">
                                        Pricing
                                    </li>
                                </ul>

                                <div className="flex justify-center items-center mt-4 space-x-2">
                                    {decryptedUserId && token ? (
                                        <span
                                            className="py-[6px] px-4 text-sm text-center rounded"
                                            style={{
                                                background: 'linear-gradient(to right, #00e89d, #0078ff)',
                                                color: '#FFFAE8',
                                                cursor: 'pointer'
                                            }}
                                            onClick={LogOutUser}
                                        >
                                            Logout
                                        </span>
                                    ) : (
                                        <>
                                            <RouterLink onClick={() => setIsModalOpen(true)}>
                                                <span
                                                    className="py-[6px] px-4 text-sm text-center rounded"
                                                    style={{
                                                        background: 'linear-gradient(to right, #00e89d, #0078ff)',
                                                        color: '#FFFAE8',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Login
                                                </span>
                                            </RouterLink>
                                            <OtpAuthModal
                                                isOpen={isModalOpen}
                                                onClose={() => setIsModalOpen(false)}
                                                message={sessionExpiredMessage}
                                            />
                                            <RouterLink
                                                to="#signup-section"
                                                className="py-[6px] px-4 text-sm text-center rounded font-semibold text-white"
                                                style={{
                                                    background: 'linear-gradient(to right, #00e89d, #0078ff)',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Signup
                                            </RouterLink>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    // Mobile hamburger menu logic - removed !authFromUrl condition
                    <>
                        {!isOpen && (
                            <button onClick={() => setIsOpen(true)} className="absolute left-4 top-4 text-white z-50">
                                <Menu className="w-6 h-6" />
                            </button>
                        )}

                        {isOpen && (
                            <div className="absolute left-0 w-full h-screen bg-gray-900 transition-all duration-300 p-2 z-50">
                                <div className="flex justify-between items-center mb-1">
                                    <h1 className="text-2xl font-semibold text-white">HevolveAI</h1>
                                    <button onClick={() => setIsOpen(false)} className="text-white">
                                        <X className="w-6 h-6" />
                                    </button>
                                </div>

                                <button
                                    onClick={handleCreateAgentClick}
                                    className={`flex items-center gap-2 mb-1 ${(decryptedUserId && token)
                                        ? 'text-orange-500 hover:text-orange-600'
                                        : 'text-gray-500 hover:text-gray-400 cursor-not-allowed'
                                        }`}
                                    title={(decryptedUserId && token) ? "Create new Agent" : "Please login to create an agent"}
                                >
                                    <Plus className="w-4 h-4" />
                                    <span>Create new Agent</span>
                                    {!(decryptedUserId && token) && <span className="text-xs">(Login required)</span>}
                                </button>

                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-300 mb-2">
                                        Display Mode
                                    </label>
                                    <select
                                        value={isTextMode ? "text" : "default"}
                                        onChange={(e) => {
                                            if (e.target.value === "text") {
                                                setIsTextMode(true);
                                            } else if (e.target.value === "default") {
                                                setIsTextMode(false);
                                            }
                                        }}
                                        className="w-full bg-gray-800 text-white border border-gray-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:bg-gray-700 transition-colors cursor-pointer"
                                    >
                                        <option value="default" className="bg-gray-800 text-white">Media Mode</option>
                                        <option value="text" className="bg-gray-800 text-white">Text Mode</option>
                                    </select>
                                </div>

                                {/* Rest of mobile menu content */}
                                <div>
                                    <h2 className="text-sm mb-2 text-white">Recents</h2>
                                    <div className="space-y-0.5">
                                        {items.map((chat, index) => (
                                            <div
                                                key={index}
                                                onClick={() => handleButtonClick(chat)}
                                                className="flex items-center gap-2 text-white hover:bg-gray-800 p-1 rounded cursor-pointer"
                                            >
                                                <img
                                                    src={chat.teacher_image_url || chat.image_url || AgentPoster}
                                                    alt={chat?.name}
                                                    className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 xl:w-14 xl:h-14 rounded-full"
                                                />
                                                <span className="truncate text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl">
                                                    {chat?.name}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                    <button
                                        onClick={() => setShowAgentsOverlay(true)}
                                        className="text-sm mt-2 hover:text-white flex items-center gap-1"
                                    >
                                        View All Agents
                                        <ChevronRight className="w-4 h-4" />
                                    </button>
                                </div>




                                {/* Google Play Button */}
                                <button className="flex justify-center flex-col w-full items-center xl:flex-row xl:justify-around">
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.hertzai.hevolve&hl=en&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                                        className="inline-block"
                                    >
                                        <img
                                            alt="Get it on Google Play"
                                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                            className="w-32 h-12 object-contain"
                                        />
                                    </a>
                                    <a
                                        href="hhttps://azurekong.hertzai.com:8443/mkt-aws/examples/0073b714-5HevolveAI_Agent_Companion_Setup_11_(1).exe
"
                                        className="inline-block font-serif text-sm mb-4"
                                    >
                                        <img
                                            alt="Download HevolveAI Companion"
                                            src="/companion.svg"
                                            className="w-32 h-12 object-contain"
                                        />
                                    </a>
                                </button>

                                <div className="mt-1">
                                    <ul className="space-y-1 text-white">
                                        <li
                                            onClick={() => navigate("/AboutHevolve")}
                                            className="cursor-pointer text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl hover:bg-gray-800 p-1 rounded flex items-center"
                                        >
                                            About Hevolve
                                        </li>
                                        <li
                                            onClick={() => navigate("/agents")}
                                            className="cursor-pointer text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl hover:bg-gray-800 p-1 rounded flex items-center"
                                        >
                                            Agents
                                        </li>
                                        <li
                                            onClick={() => navigate("/aboutus")}
                                            className="cursor-pointer text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl hover:bg-gray-800 p-1 rounded flex items-center"
                                        >
                                            About Us
                                        </li>
                                        <li
                                            onClick={() => navigate('/Plan')}
                                            className="cursor-pointer text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl hover:bg-gray-800 p-1 rounded flex items-center"
                                        >
                                            Pricing
                                        </li>
                                    </ul>
                                </div>

                                <div className="left-4 flex items-center gap-2 cursor-pointer mt-2">
                                    <button className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center">
                                        <span className="text-white">
                                            {decryptedEmail ? decryptedEmail.charAt(0).toUpperCase() : ''}
                                        </span>
                                    </button>
                                    <span className="text-sm text-white">
                                        {decryptedEmail}
                                    </span>
                                </div>

                                <div className="mt-1 flex justify-center gap-1">
                                    <button
                                        className="py-2 px-4 rounded text-white"
                                        style={{
                                            background: 'linear-gradient(to right, #00e89d, #0078ff)',
                                            cursor: 'pointer',
                                        }}
                                        onClick={LogOutUser}
                                    >
                                        Logout
                                    </button>
                                </div>
                            </div>
                        )}
                    </>

                )}


                < div className="flex flex-col h-screen bg-black w-full   " >

                    <div className="w-full flex flex-col md:flex-row-reverse overflow-auto h-screen">
                        {/* Chat/Messages section - Now on the left for wider screens */}


                        {/* Artifact section (video/audio/image/PDF) - Now on the right */}
                        <div className={`${!uploadedImage && !uploadedPdf && (window.innerWidth > 768) ? 'w-[30%]' : 'w-full'} 
        ${window.innerWidth <= 768 ? 'h-[35vh]' : ''} flex justify-center items-center`}>
                            {!isTextMode && (
                                <>
                                    {!uploadedImage && !uploadedPdf ? (
                                        <>
                                            {videoUrl ? (
                                                <video
                                                    src={videoUrl}
                                                    width={getVideoWidth()}
                                                    onLoadedMetadata={handleLoadedMetadata}
                                                    className={`object-cover rounded-lg animate-fade-in ${window.innerWidth <= 768 ? 'relative  top-[2.2rem]' : 'absolute bottom-44 right-5'}`}
                                                    autoPlay
                                                    ref={videoRef}
                                                    muted
                                                    controlsList="nodownload noplaybackrate"
                                                    controls={false}
                                                    onEnded={handleMediaEnded}
                                                />
                                            ) : audioUrl ? (
                                                <div className="fixed flex flex-col justify-center items-center  p-4" >
                                                    <div className="flex items-center space-x-4 justify-center mt-5 px-4 py-4">
                                                        <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center">
                                                            <button className="text-gray-700 text-xl">▶️</button>
                                                        </div>
                                                    </div>
                                                    <div className="mt-4 w-full max-w-md">
                                                        <audio
                                                            ref={audioRef}
                                                            src={audioUrl}
                                                            className="w-full"
                                                            autoPlay
                                                            controlsList="nodownload noplaybackrate"
                                                            controls={false}
                                                            onLoadedMetadata={handleLoadedMetadataaudio}
                                                            onEnded={handleMediaEnded}
                                                        />
                                                    </div>
                                                </div>
                                            ) : null}
                                        </>
                                    ) : (
                                        <div className={`${window.innerWidth <= 768 ? 'h-full' : 'h-[85vh]'} w-full flex flex-col items-center justify-between gap-4`}>
                                            <>
                                                {videoUrl ? (
                                                    <div className="w-full">
                                                        <video
                                                            src={videoUrl}
                                                            width="100%"
                                                            height="auto"
                                                            className={`${window.innerWidth <= 768 ? 'h-[15vh]' : 'h-[40vh]'} w-full object-contain rounded-lg animate-fade-in`}
                                                            autoPlay
                                                            ref={videoRef}
                                                            muted
                                                            controlsList="nodownload noplaybackrate"
                                                            controls={false}
                                                            onLoadedMetadata={handleLoadedMetadata}
                                                            onEnded={handleMediaEnded}
                                                        />
                                                    </div>
                                                ) : audioUrl ? (
                                                    <div className="w-full">
                                                        <div className="flex items-center space-x-4 justify-center mt-5 px-4 py-4">
                                                            <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center">
                                                                <button className="text-gray-700 text-xl">▶️</button>
                                                            </div>
                                                        </div>
                                                        <div className="mt-4">
                                                            <audio
                                                                ref={audioRef}
                                                                src={audioUrl}
                                                                className="w-full"
                                                                autoPlay
                                                                controlsList="nodownload noplaybackrate"
                                                                controls={false}
                                                                onLoadedMetadata={handleLoadedMetadataaudio}
                                                                onEnded={handleMediaEnded}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </>

                                            {(uploadedImage || uploadedPdf) && (
                                                <div className="fixed top-5 bg-black bg-opacity-75 flex justify-center items-center z-50">
                                                    <div className="relative bg-white p-4 rounded-lg shadow-lg w-[90%] max-w-4xl">
                                                        {/* Close Button */}
                                                        <button
                                                            onClick={() => {
                                                                setUploadedImage(null);
                                                                setUploadedPdf(null);
                                                            }}
                                                            className="absolute top-2 right-2 bg-gray-300 hover:bg-gray-400 rounded-full p-2"
                                                        >
                                                            ✕
                                                        </button>

                                                        {/* Image Display */}
                                                        {uploadedImage && (
                                                            <div className="w-full">
                                                                <img
                                                                    src={uploadedImage}
                                                                    alt="Content Image"
                                                                    className={`${window.innerWidth <= 768 ? 'h-[60vh]' : 'h-[70vh]'} w-full object-contain rounded-lg`}
                                                                />
                                                            </div>
                                                        )}

                                                        {/* PDF Display */}
                                                        {uploadedPdf && (
                                                            <div
                                                                ref={containerRef}
                                                                className="relative w-full border-2 border-gray-200 rounded-lg flex justify-center items-center h-[75vh]"
                                                            >
                                                                <Document file={uploadedPdf} onLoadSuccess={onDocumentLoadSuccess}>
                                                                    <Page pageNumber={currentPage} scale={scale} className="flex justify-center items-center h-full" />
                                                                </Document>

                                                                {/* Pagination */}
                                                                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white shadow-lg rounded-full flex items-center">
                                                                    <button
                                                                        onClick={prevPage}
                                                                        className="px-3 py-2 bg-gray-300 rounded-full flex items-center justify-center cursor-pointer"
                                                                    >
                                                                        <ChevronLeft size={16} />
                                                                    </button>
                                                                    <span className="text-sm font-medium px-2">
                                                                        Page {currentPage} of {numPages}
                                                                    </span>
                                                                    <button
                                                                        onClick={nextPage}
                                                                        className="px-3 py-2 bg-gray-300 rounded-full flex items-center justify-center cursor-pointer"
                                                                    >
                                                                        <ChevronRight size={16} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}

                            {codeContent && (
                                <div className="mt-4 bg-black p-4 rounded-lg shadow-md">
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">Code Snippet</h3>
                                    <pre className="bg-gray-100 p-2 rounded-md text-sm overflow-auto">
                                        <code>{codeContent}</code>
                                    </pre>
                                    <button
                                        onClick={() => setCodeContent(null)}
                                        className="mt-2 bg-red-500 text-white px-3 py-1 rounded-md"
                                    >
                                        Close Code
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Chat/Messages section */}
                        <div className={`${window.innerWidth <= 768 ? 'h-[60vh]' : ''} flex-1 w-full md:w-[60%]`}>
                            {messages.length === 0 ? (
                                <div className="h-5/6 flex items-center justify-center">
                                    <div className="text-center space-y-4 mb-1">
                                        <h1 className="animate-fade-in text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight mb-3">
                                            {currentAgent?.name}
                                        </h1>
                                        <h2 className="text-2xl font-medium text-white-900 animate-fade-in">
                                            How can I help you today?
                                        </h2>
                                        <p className="text-white-600 animate-fade-in">
                                            I'm an AI agent. I'm here to help with various task!
                                        </p>
                                        <p className="text-white-600 animate-fade-in">
                                            {(currentAgent?.video_text === "This is Static Description" || agentData?.video_text === "This is Static Description")
                                                ? ""
                                                : (currentAgent?.video_text)}
                                        </p>
                                        {!(decryptedUserId && token) && (<ul className="buy-button list-none mb-0">
                                            <li className="inline mb-0">
                                                <RouterLink
                                                    onClick={() => setIsModalOpen(true)}
                                                    className="py-[6px] px-4 inline-block text-sm text-center rounded"
                                                    style={{
                                                        background: 'linear-gradient(to right, #00e89d, #0078ff)',
                                                        borderColor: '#00f0c5',
                                                        color: '#FFFAE8',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s ease',
                                                    }}
                                                >
                                                    Login
                                                </RouterLink>
                                                <OtpAuthModal
                                                    isOpen={isModalOpen}
                                                    onClose={() => setIsModalOpen(false)}
                                                />
                                            </li>
                                            <span className="mx-4">OR</span>
                                            <li className="inline mb-0 ps-1">
                                                <RouterLink
                                                    onClick={() => {
                                                        const element = document.getElementById("signup-section");
                                                        element?.scrollIntoView({ behavior: "smooth" });
                                                    }}
                                                    to="#signup-section"
                                                    className="py-[6px] px-4 inline-block text-sm text-center rounded text-white font-semibold"
                                                    style={{
                                                        background: 'linear-gradient(to right, #00e89d, #0078ff)',
                                                        borderColor: '#FFFAE8',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s ease',
                                                    }}
                                                >
                                                    Signup
                                                </RouterLink>
                                            </li>
                                        </ul>)}
                                    </div>
                                </div>
                            ) : (
                                <div className="max-w-5xl mx-auto p-4 space-y-6 h-full">
                                    {messages.map((message, index) => {
                                        if (message.type === 'thinking_container') {
                                            return (
                                                <ThinkingProcessContainer
                                                    key={`thinking-container-${message.id}-${index}`}
                                                    thinkingMessages={message.thinkingSteps}
                                                    isMainExpanded={message.isMainExpanded}
                                                    onToggleMain={() => {
                                                        setMessages(prev =>
                                                            prev.map((msg, msgIndex) =>
                                                                msgIndex === index
                                                                    ? { ...msg, isMainExpanded: !msg.isMainExpanded }
                                                                    : msg
                                                            )
                                                        );
                                                    }}
                                                    onToggleIndividual={(stepId) => {
                                                        setMessages(prev =>
                                                            prev.map((msg, msgIndex) =>
                                                                msgIndex === index
                                                                    ? {
                                                                        ...msg,
                                                                        thinkingSteps: msg.thinkingSteps.map(step =>
                                                                            step.id === stepId
                                                                                ? { ...step, isExpanded: !step.isExpanded }
                                                                                : step
                                                                        )
                                                                    }
                                                                    : msg
                                                            )
                                                        );
                                                    }}
                                                />
                                            );
                                        }

                                        // Regular user/assistant messages
                                        return (
                                            <div
                                                key={index}
                                                className="rounded-lg p-6 shadow-sm"
                                                style={{
                                                    backgroundColor: message.type === "user" ? "#EFEAAA" : "#212A31",
                                                    color: message.type === "user" ? "#000000" : "#FFFFFF"
                                                }}
                                            >
                                                <div className="flex-1 space-y-4">
                                                    <div className={message.type === "user" ? "text-black font-bold" : "text-white"}>
                                                        {message.type === "user" && (
                                                            <div className="space-y-2">
                                                                <div>{message.content}</div>

                                                                {message.pdf && (
                                                                    <div className="flex flex-col gap-2 mt-2">
                                                                        <div className="flex items-center gap-2">
                                                                            <FileText className="w-5 h-5 text-gray-500" />
                                                                            <span className="text-sm text-gray-700">Understanding the Content: {progress}%</span>
                                                                        </div>

                                                                        <div className="w-full h-4 bg-gray-200 rounded-full overflow-hidden">
                                                                            <div
                                                                                className="h-full bg-blue-600 transition-all duration-300 ease-out rounded-full"
                                                                                style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                                                                            />
                                                                        </div>

                                                                        <button
                                                                            onClick={() => handlePdfClick(message.pdf)}
                                                                            className="text-blue-600 hover:text-blue-800 underline flex items-center gap-2"
                                                                        >
                                                                            <FileText className="w-5 h-5" />
                                                                            View Uploaded PDF
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                {message.image && (
                                                                    <div className="mt-2">
                                                                        <img
                                                                            src={message.image}
                                                                            alt="Uploaded"
                                                                            className="w-16 h-16 rounded-lg shadow-md cursor-pointer"
                                                                            onClick={() => handleImageClick(message.image)}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                        {message.type === "assistant" && (
                                                            <>
                                                                {isTextMode ? (
                                                                    <div>{message.content}</div>
                                                                ) : (
                                                                    duration > 0 ? (
                                                                        <TypeWriterForSubtitle
                                                                            text={message.content}
                                                                            duration={duration}
                                                                            isIdle={isIdleVideo(videoUrl)}
                                                                        />
                                                                    ) : (
                                                                        <div>{message.content}</div>
                                                                    )
                                                                )}
                                                            </>
                                                        )}
                                                    </div>

                                                    {message.code && (
                                                        <button
                                                            onClick={() => setCodeContent(message.code)}
                                                            className="bg-blue-500 text-white px-3 py-1 rounded-md"
                                                        >
                                                            Show Code
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}

                                    {/* Loading indicator when waiting for response (only show if no active thinking) */}
                                    {loading && !currentThinkingId && (
                                        <div className="flex items-center justify-start space-x-3">
                                            <span className="w-2 h-2 bg-gray-500 rounded-full animate-pulse"></span>
                                            <span className="w-2 h-2 bg-gray-500 rounded-full animate-pulse delay-200"></span>
                                            <span className="w-2 h-2 bg-gray-500 rounded-full animate-pulse delay-400"></span>
                                        </div>
                                    )}

                                    <div ref={messagesEndRef} />
                                </div>

                            )}
                        </div>
                    </div>


                    <div className="bg-black pt-4 border-t border-gray-700 flex justify-center flex-col mt-2 mb-2">
                        {pdfFile && (
                            <div className="relative inline-block mt-4">
                                <span className="text-gray-700">Uploaded PDF: {pdfFile.name}</span>
                                <button
                                    onClick={handleRemovePdf}
                                    className="text-red-600 hover:text-red-800 p-1 ml-2"
                                >
                                    Remove
                                </button>
                            </div>
                        )}
                        {
                            userImage && (
                                <div className="relative inline-block mt-4" >
                                    <span className="text-gray-700" > Uploaded Image: </span>
                                    < img
                                        src={userImage}
                                        alt="Uploaded"
                                        className="w-16 h-16 object-cover rounded-lg shadow-md mt-2"
                                    />
                                    <button
                                        onClick={handleRemoveImage}
                                        className="text-red-600 hover:text-red-800 p-1 ml-2"
                                    >
                                        Remove
                                    </button>
                                </div>
                            )
                        }

                        <div className="flex items-center w-[95%] relative">
                            <textarea
                                ref={textareaRef}
                                disabled={!(decryptedUserId && token)}
                                value={inputMessage}
                                onChange={(e) => {
                                    setInputMessage(e.target.value);
                                    e.target.style.height = "auto";
                                    e.target.style.height = `${e.target.scrollHeight}px`;

                                    if (e.target.scrollHeight > 200) {
                                        e.target.style.height = "200px";
                                        e.target.style.overflowY = "scroll";
                                    } else {
                                        e.target.style.overflowY = "hidden";
                                    }
                                }}
                                placeholder="Message..."
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                onKeyPress={handleKeyPress}
                                className="w-full text-black border bg-[#fff8ea] text-base border-gray-200 rounded-lg px-4 py-3 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 break-words overflow-wrap-anywhere whitespace-pre-wrap"
                                style={{
                                    minHeight: "44px",
                                    maxHeight: "200px",
                                    wordWrap: 'break-word',
                                    overflowWrap: 'anywhere',
                                    wordBreak: 'break-word',
                                    whiteSpace: 'pre-wrap'
                                }}
                            />




                            {!(decryptedUserId && token) && (
                                <button onClick={() => setIsModalOpen(true)} className="absolute text-white bg-black p-2 rounded-lg top-[40px] left-0">
                                    Please login to talk to agent.
                                </button >
                            )}


                            <button
                                onClick={() => document.getElementById("fileInput").click()}
                                className="text-gray-400 hover:text-gray-600 p-1"
                            >
                                <Image className="w-5 h-5" />
                            </button>


                            <button
                                onClick={() => document.getElementById("pdfInput").click()}
                                className="text-gray-400 hover:text-gray-600 p-1"
                            >
                                <FileText className="w-5 h-5" />
                            </button>
                            {!isRecording ? (
                                <button
                                    onClick={handleStart}
                                    className="text-green-500 hover:text-green-700 p-1 flex items-center gap-1"
                                >
                                    <Mic className="w-5 h-5" />
                                </button>
                            ) : (
                                <button
                                    onClick={handleStop}
                                    className="text-red-500 hover:text-red-700 p-1 flex items-center gap-1"
                                >
                                    <span>Stop</span>
                                </button>
                            )}

                            <button
                                disabled={!(decryptedUserId && token)}
                                onClick={handleSend}
                                className="text-gray-400 hover:text-gray-600 p-1"
                            >
                                <SendHorizontal className="w-5 h-5" />
                            </button>


                            <input
                                type="file"
                                id="fileInput"
                                accept="image/*"
                                onChange={handleImageSelect}
                                className="hidden"
                            />
                            <input
                                type="file"
                                id="pdfInput"
                                accept="application/pdf"
                                onChange={handlePdfSelect}
                                className="hidden"
                            />
                        </div>






                    </div>

                </div>


            </div >
            {!(decryptedUserId && token) && <NewHome />}









            {
                showAgentsOverlay && (
                    <Agents
                        isOverlay={true}
                        onClose={() => setShowAgentsOverlay(false)}
                        onAgentSelect={handleAgentSelect}
                        predefinedAgents={allAgents}
                    />
                )
            }
            {
                showCreateAgentForm && (
                    <CreateAgentForm
                        onClose={() => setShowCreateAgentForm(false)}
                        onSubmit={handleCreateAgentSubmit}
                        userId={decryptedUserId}
                    />
                )
            }



            {
                screenWidth > 768 && (
                    <div className="absolute top-4 right-44 z-500">
                        <select
                            onChange={(e) => {
                                if (e.target.value === "text") {
                                    setIsTextMode(true);
                                } else if (e.target.value === "default") {
                                    setIsTextMode(false);
                                }
                            }}
                            className="
                        bg-gray-800 
                        text-white 
                        border border-gray-600 
                        rounded-lg 
                        px-3 py-2 
                        text-sm 
                        focus:outline-none 
                        focus:ring-2 
                        focus:ring-blue-500 
                        focus:border-transparent
                        hover:bg-gray-700
                        transition-colors
                        cursor-pointer
                        min-w-[120px]
                    "
                        >
                            <option value="default" className="bg-gray-800 text-white">Default Mode</option>
                            <option value="text" className="bg-gray-800 text-white">Text Mode</option>
                        </select>
                    </div>
                )
            }

            {/* Companion Status */}
            <div className="absolute top-0 right-8 z-500 flex items-center space-x-2">
                {companionStatus && (
                    <img
                        src={
                            companionStatus.isRunning
                                ? connectedImg
                                : DisconnectedImg
                        }
                        alt="Connection Status"
                        className="w-16 h-16"
                        title={companionStatus.isRunning ? "Connected" : "Companion App Disconnected"}
                    />
                )}
            </div>

            {/* Creation Mode Animation */}
            <div className="absolute top-0 right-24 z-50 flex items-center space-x-2">
                {currentAgent?.agent_status === 'Creation Mode' && (
                    <div className="relative w-16 h-16">
                        <Lottie
                            animationData={creationModeAnimation}
                            loop={true}
                            autoplay={true}
                            className="w-16 h-16"
                            title="Agent Creation Mode"
                        />
                        <span className="absolute inset-0 flex items-center justify-center text-white text-[8px] font-medium pointer-events-none">
                            Creation mode
                        </span>
                    </div>
                )}

            </div>






            {
                showNotification && !companionStatus.isInstalled ? (
                    <div className="companion-warning absolute top-1 left-1/2 transform -translate-x-1/2 bg-gray-200 p-4 rounded-md shadow-md">
                        <p className="text-red-600 font-semibold">HevolveAI Agent Companion App is not installed.</p>
                        <a
                            href="https://azurekong.hertzai.com:8443/mkt-aws/examples/0073b714-5HevolveAI_Agent_Companion_Setup_11_(1).exe
"


                            download
                            className="mt-2 inline-block bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
                        >
                            Install HevolveAI Agent Companion App
                        </a>
                    </div>
                ) : (showNotification && !companionStatus.isRunning && (
                    <div className="companion-warning absolute top-1 left-1/2 transform -translate-x-1/2 bg-gray-200 p-4 rounded-md shadow-md">
                        <p className="text-red-600 font-semibold">HevolveAI Agent Companion App is installed but not running.</p>
                    </div>
                ))
            }

        </>


    );
};

export default ChatInterface;